import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { AccountGridCard } from './account-grid-card.component'
import { AccountAddNewCard } from './account-add-new-card.component'
import {
  EAccountRoles,
  EUserRoles,
  IAccountByIdDto,
  IAccountsAllResp,
  IGridPopperListItem,
} from 'src/types'
import { useMe, useUpdateAccountPublicStatus, useUpdateAccountSuspension, useUser } from 'src/hooks'

import { useStyles } from './styles'
import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { useTranslation } from 'react-i18next'

interface IAccountsGridProps {
  withAddition?: boolean
  data: (IAccountsAllResp | IAccountByIdDto)[]
  withSuspension?: boolean
  withOptions?: boolean
  showStatus?: boolean
}

const getRolesString = (account: IAccountByIdDto | null | undefined | void) => {
  let accountRole = ''

  if (
    account &&
    account.users &&
    account.users.length > 0 &&
    account.users[0]?.roles &&
    account.users[0]?.roles.length > 0
  ) {
    accountRole =
      account.users[0].roles[0].charAt(0).toUpperCase() + account.users[0].roles[0].slice(1)
  }

  return accountRole
}

const AccountsGrid = ({
  withAddition,
  data,
  withSuspension,
  withOptions,
  showStatus,
}: IAccountsGridProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const navigate = useNavigate()
  const { mutateAsync: updateSuspension } = useUpdateAccountSuspension()
  const { data: user } = useUser()
  const { data: userData } = useMe()

  const { mutateAsync: updatePublickStatus } = useUpdateAccountPublicStatus()

  const handlePublicChange = (id: string, publicStatus: boolean) => {
    updatePublickStatus({ id, public: publicStatus })
  }

  const createItems = (id: string, publicStatus: boolean) => {
    const items: IGridPopperListItem[] = [
      {
        title: publicStatus ? t('not-public-button-lable.v') : t('public-button-lable.v'),
        onClick: () => handlePublicChange(id, !publicStatus),
        disabled: false,
      },
    ]

    return items
  }

  const handleAddClick = () => {
    navigate(`add`)
  }

  const handleCompanyLogin = (id: string, roles: EAccountRoles[]) => () => {
    roles?.includes(EAccountRoles.scanner)
      ? navigate(joinAbsRoute(ROUTES.ACCOUNTS, id, ROUTES.SCAN_HISTORY))
      : navigate(joinAbsRoute(ROUTES.ACCOUNTS, id, ROUTES.DASHBOARD))
  }

  const handleSuspension = (id: string, suspended: boolean) => async () => {
    await updateSuspension({ id, suspended: !suspended })
  }

  return (
    <Grid container className={classes.gridListWrapper}>
      {data.map((item) => (
        <AccountGridCard
          withSuspended={withSuspension}
          suspended={item.suspended}
          image={item.image_medium || item.image}
          name={item.account_holder}
          key={item.id}
          subscription={item.subscription_plan}
          onButtonClick={handleCompanyLogin(item.id, item.users?.[0]?.roles)}
          handleSuspension={handleSuspension(item.id, item.suspended)}
          userRoleForAccount={getRolesString(item)}
          items={withOptions ? createItems(item.id, item.public) : []}
          showStatus={showStatus}
          status={item.public}
          ai_generated={item.ai_generated}
        />
      ))}
      {withAddition &&
        (user?.roles.includes(EUserRoles.superadmin) ||
          (userData?.customer && data?.length === 0)) && (
          <AccountAddNewCard
            handleAdditionClick={handleAddClick}
            additionalText={data?.length > 0 ? '' : 'account-add-button-secondary-text'}
          />
        )}
    </Grid>
  )
}

export { AccountsGrid }
